"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyUpdateStudioProjectV1StudioProjectsProjectIdPost = void 0;
var BodyUpdateStudioProjectV1StudioProjectsProjectIdPost_1 = require("./BodyUpdateStudioProjectV1StudioProjectsProjectIdPost");
Object.defineProperty(exports, "BodyUpdateStudioProjectV1StudioProjectsProjectIdPost", { enumerable: true, get: function () { return BodyUpdateStudioProjectV1StudioProjectsProjectIdPost_1.BodyUpdateStudioProjectV1StudioProjectsProjectIdPost; } });
